// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Link, { LinkPresentationProps } from "@store/MobiusOverrides/Link/Link";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { resultCountProps } from "@store/Themes/common/props/resultCount";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import OpenAllStyleguideSections from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/Handlers/OpenAllStyleguideSections";
import { useHasAllStyleguideSectionsOpen } from "@toolkit/Framework/Store/Toolkit/Components/Styleguide/StyleguideHooks";
import React, { FC } from "react";
import { css } from "styled-components";

interface Styles {
    wrapper?: InjectableCss;
    actionLinksWrapper?: InjectableCss;
    actionLinks?: LinkPresentationProps;
}

const styles: Styles = {
    wrapper: resultCountProps.wrapper,
    actionLinks: {
        css: css`
            ${linkActionStyles()}
            ${inlineSeparatorStyles({ spacing: pxToRem(23) })}
        `,
    },
};

const StyleguideNavigation: FC = () => {
    const dispatch = useAppDispatch();
    const hasAllSectionsOpen = useHasAllStyleguideSectionsOpen();

    const onCollapse = (event: React.MouseEvent) => {
        event.stopPropagation();
        dispatch(OpenAllStyleguideSections({ isOpen: false }));
    };

    const onExpand = (event: React.MouseEvent) => {
        event.stopPropagation();
        dispatch(OpenAllStyleguideSections({ isOpen: true }));
    };

    return (
        <StyledWrapper {...styles.wrapper}>
            <StyledWrapper {...styles.actionLinksWrapper}>
                <Link
                    onClick={onCollapse}
                    {...styles.actionLinks}
                    id="collapseButton"
                    disabled={hasAllSectionsOpen === false}
                >
                    {translate("Collapse All")}
                </Link>
                <Link
                    onClick={onExpand}
                    {...styles.actionLinks}
                    id="expandButton"
                    disabled={hasAllSectionsOpen === true}
                >
                    {translate("Expand All")}
                </Link>
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default StyleguideNavigation;
